import React from "react";
import { ShieldCheck, Clock, Award, Users } from "lucide-react";

const STATS = [
  { icon: Award, value: "Desde 1972", label: "Más de 50 años de experiencia" },
  { icon: ShieldCheck, value: "100%", label: "Compromiso con la seguridad" },
  { icon: Clock, value: "Rápida", label: "Atención y entrega a domicilio" },
  { icon: Users, value: "Cercanía", label: "Trato profesional y humano" },
];

export default function About() {
  return (
    <section id="sobre" data-testid="about-section" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <span className="divider-orange mb-5" />
            <p className="font-mono-cima text-xs uppercase tracking-widest text-[var(--cima-red)] mb-3">
              Sobre Nosotros · Desde 1972
            </p>
            <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl leading-tight text-[var(--cima-navy)]">
              Confianza industrial, atención profesional.
            </h2>
            <div className="mt-6 inline-flex items-center gap-3 border border-slate-300 bg-white px-4 py-3">
              <span className="font-display font-extrabold text-3xl lg:text-4xl text-[var(--cima-red)] leading-none">
                +50
              </span>
              <span className="text-xs font-mono-cima uppercase tracking-widest text-slate-600 leading-tight">
                Años<br />de trayectoria
              </span>
            </div>
          </div>

          <div className="lg:col-span-7">
            <p className="text-base sm:text-lg text-slate-600 leading-relaxed">
              <strong className="text-[var(--cima-navy)]">CIMA – Comercializadora Industrial Médica</strong>{" "}
              opera <strong className="text-[var(--cima-red)]">desde 1972</strong>, ofreciendo
              soluciones confiables en gases industriales y medicinales para la industria, hospitales,
              talleres mecánicos, soldadores, laboratorios y negocios locales en Zihuatanejo y la región.
            </p>
            <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
              Más de medio siglo de experiencia nos respalda. Trabajamos bajo estrictos protocolos de
              manejo seguro y calidad certificada, brindando asesoría técnica especializada, equipos
              confiables y atención rápida — porque sabemos que cada cilindro que entregamos sostiene
              un proceso, una operación o una vida.
            </p>

            <div className="mt-10 grid grid-cols-2 gap-px bg-slate-200 border border-slate-200">
              {STATS.map((s, i) => (
                <div
                  key={s.label}
                  data-testid={`about-stat-${i}`}
                  className="bg-white p-6 metallic-sheen"
                >
                  <s.icon className="w-6 h-6 text-[var(--cima-red)] mb-3" />
                  <div className="font-display font-bold text-2xl text-[var(--cima-navy)]">
                    {s.value}
                  </div>
                  <div className="text-sm text-slate-600 mt-1">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
